module.exports = __webpack_public_path__ + "img/package.37ac428e.svg";